import Message from "../../message";
import {useMainStore} from "@/store";

export default class MemberDemoted extends Message
{
    handle()
    {
        useMainStore().DEMOTE_GUILD_MEMBER(this.message.user_id);
    }
}
